import { Component, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxStarsModule } from 'ngx-stars';
declare var Swiper: any;

@Component({
  selector: 'app-customer-says',
  standalone: true,
  imports: [CommonModule, NgxStarsModule],
  templateUrl: './customer-says.component.html',
  styleUrl: './customer-says.component.css'
})
export class CustomerSaysComponent implements AfterViewInit {

  ngAfterViewInit() {
    setTimeout(() => {
      this.initCustomerSaySwiper();
    }, 0);
  }

  initCustomerSaySwiper() {
    new Swiper('.customerSaySwiper', {
      spaceBetween: 16,
      navigation: {
        nextEl: '.customerSay-next',
        prevEl: '.customerSay-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1.4,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}
